export default {
  CalmosAdminAction: 'CalmosAdminAction',
  CalmosSuperAdminAction: 'CalmosSuperAdminAction',
  CalmosExpertAction: 'CalmosExpertAction',
  DeleteShade: 'prv_shade_delete'
};
